'use strict';

angular.module('cloudBillingLegacyFrontend').controller('EaConfiguredAreaCtrl', [ '$scope', '$eaConfig', function ($scope, $eaConfig) {

  // defined some view related information
  $scope.configured = false  

}]);
